import React, { useState, useEffect } from "react";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Paper,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Modal,
  Chip,
  Grow,
} from "@mui/material";
import { ArrowDropDown, DeleteOutline, Search } from "@mui/icons-material";
// import { serverUrl } from '../server';
import { getRequest, patchRequest, server } from "../config";
import moment from "moment";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
const Requests = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [customers, setCustomers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedCity, setSelectedCity] = useState("");
  const [allCities, setallCities] = useState([]);
  const [backData, setbackData] = useState([]);
  const [actualValue, setactualValue] = useState({ name: "All Cities" });
  const [open, setOpen] = useState(false);
  const [filter, setfilter] = useState({});
  const [editOpen, seteditOpen] = useState(false);
  const [editedMessage, seteditedMessage] = useState("");
  const [selectedId, setselectedId] = useState({});
  const [showPartners, setshowPartners] = useState(false);
  const [activeRequest, setactiveRequest] = useState({});
  const [availablePartners, setavailablePartners] = useState([]);
  const [showAddresses, setShowAddresses] = useState(false);
  const [userAddresses, setUserAddresses] = useState([]);
  const handleAssignWork = () => {
    "";
  };
  const fetchAvailablePartners = async (subCategoryId, userId) => {
    try {
      const uri =
        server.uri +
        `requests?filter={"where":{"subCategoryId":"${subCategoryId}","userId":"${userId}"},"include":[{"relation":"partner"}]}`;
      const requestedParters = await getRequest(uri);
      setavailablePartners(requestedParters);
    } catch (error) {}
  };
  const fetchUserAddresses = async (userId) => {
    try {
      const uri = server.uri + `user-addresses?filter={"where":{"userId":"${userId}"}}`;
      const addresses = await getRequest(uri);
      setUserAddresses(addresses);
      setShowAddresses(true);
    
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };
  const handleDrawerOpen = async (service) => {
    // await fetchActivePartner(service?.partnerId);
    await fetchAvailablePartners(service?.subCategoryId, service?.userId);
    setshowPartners(true);
  };
  const handleClickOpen = (id) => {
    setfilter({ subCategoryId: id?.subCategoryId, userId: id?.userId });
    setOpen(true);
  };
  useEffect(() => {
    fetchCustomers();
  }, [searchQuery, page, rowsPerPage, selectedCity]);
  const handleChange = (e) => {
    seteditedMessage(e.target.value);
  };
  const handleUpdate = async () => {
    try {
      const uri =
        server.uri +
        `requests/user?userId=${selectedId?.userId}&&subCategoryId=${selectedId?.subCategoryId}`;
      const updatedData = await patchRequest(uri);
      if (updatedData == 204) {
        seteditOpen(false);
      }
    } catch (error) {}
  };
  const handleDelete = async () => {
    try {
      const uri =
        server.uri +
        `requests/bulk/filter?userId=${filter?.userId}&&subCategory=${filter?.subCategoryId}`;
      const deleteRequest = await axios.delete(uri);
      if (deleteRequest) {
        setOpen(false);
        await fetchCustomers();
      }
    } catch (error) {
      alert(JSON.stringify(error));
    }
  };
  // Fetch customers from the LoopBack backend with filter and pagination

  const fetchCities = async () => {
    try {
      const uri = server.uri + "cities";
      const citiesData = await getRequest(uri);
      if (citiesData) {
        setallCities(citiesData);
        setbackData(citiesData);
      }
    } catch (error) {}
  };
  useEffect(() => {
    fetchCities();
  }, []);

  const fetchCustomers = async () => {
    try {
      const filter = {
        where: {
          or: [
            { name: { like: `%${searchQuery}%` } },
            { email: { like: `%${searchQuery}%` } },
            { pincode: { like: `%${searchQuery}%` } },
          ],
        },
        skip: page * rowsPerPage,
        limit: rowsPerPage,
      };

      const response = await getRequest(
        `${server.uri}requests/unique-by-user?filter={
        "where":{
        "or":[
        {"name":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}},
         {"pincode":{"like":"${searchQuery}"}}
        
      ],"userType":"manager","city":"${selectedCity}"},"skip":"${filter.skip}",
        
        "order":"createdAt desc"}`
      );
      //   console.log(response);

      setCustomers(response);
      // const responseCount = await getRequest(
      //   `${server.uri}requests/unique-by-user/count?where={

      //   "or":[
      //   {"name":{"like":"${searchQuery}"}},
      //   {"mobileNumber":{"like":"${searchQuery}"}},
      //    {"mobileNumber":{"like":"${searchQuery}"}}
      // ],"userType":"manager","city":"${selectedCity}"}`
      // );

      // console.log(responseCount);
      setTotalCount(customers.length);
      // setTotalCount(responseCount.count);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  // Handle search query change
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to the first page when search changes
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when rows per page changes
  };
  const handleCityChange = (event, value) => {
    setSelectedCity(value?.name);
    setactualValue(value);
    setPage(0); // Reset to the first page when city changes
  };

  const cities = ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix"]; // Example city list
  return (
    <Container>
      <Typography variant="h4" sx={{ marginTop: 8, marginBottom: 2 }}>
        Request List
      </Typography>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Delete Service"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are You Sure to Delete Service?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => handleDelete(filter)}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={editOpen} onClose={() => seteditOpen(false)}>
        <DialogTitle>Edit Message</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            multiline
            variant="outlined"
            label="Message"
            value={editedMessage}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => seteditOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleUpdate} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Search Bar */}
      {/* <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
    
        <TextField
          variant="outlined"
          placeholder="Search by name/mobile number/pincode"
          fullWidth
          value={searchQuery}
          onChange={handleSearch}
          InputProps={{
            startAdornment: <Search sx={{ color: "gray", marginRight: 1 }} />,
          }}
          sx={{ marginRight: 2 }}
        />

      
        <FormControl variant="outlined" sx={{ minWidth: 200 }}>
        
          <Autocomplete
            value={actualValue}
            onChange={handleCityChange}
          
            getOptionLabel={(option) => option?.name}
            options={allCities}
            fullWidth
            freeSolo
            renderInput={(params) => (
              <TextField
                onch
                {...params}
                label="Search City"
                variant="outlined"
                fullWidth
              />
            )}
            renderOption={(props, option) => (
              <MenuItem {...props} key={option?.cityId}>
                {option?.name}
              </MenuItem>
            )}
          />
        </FormControl>
      </Box> */}
      <Typography variant="subtitle1" sx={{ textAlign: "right" }} gutterBottom>
        Total Requests: <strong>{customers?.length}</strong>
      </Typography>
      {/* Customer Table */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f4f6f8", // Light background for table header
                }}
              >
                <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>

                <TableCell sx={{ fontWeight: "bold" }}>Phone</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>City</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Address</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Sub Category</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Requirements</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Requested At</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}></TableCell>
                <TableCell sx={{ fontWeight: "bold" }}></TableCell>
                <TableCell sx={{ fontWeight: "bold" }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers?.map((customer) => (
                <TableRow
                  sx={{
                    "&:nth-of-type(even)": {
                      backgroundColor: "#f9fafb", // Alternate row color for better readability
                    },
                  }}
                  key={customer.userId}
                >
                  <TableCell>{customer?.user?.name}</TableCell>

                  <TableCell>{customer?.user?.mobileNumber}</TableCell>
                  <TableCell>{customer?.user?.city}</TableCell>
                  <TableCell>{customer?.fullAddress}</TableCell>
                  <TableCell>{customer?.category}</TableCell>
                  <TableCell>{customer?.subCategory}</TableCell>
                  <TableCell>{customer?.requirement}</TableCell>
                  <TableCell>
                    {moment(customer?.createdAt).startOf("hour").fromNow()}
                  </TableCell>
                  <TableCell>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => handleDrawerOpen(customer)}
                    >
                      Partners
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button
                      color="info"
                      variant="contained"
                      onClick={() => {fetchUserAddresses(customer?.userId)
                      setactiveRequest(customer)
                      }}
                    >
                      View Address
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button
                      color="error"
                      variant="contained"
                      onClick={() => handleClickOpen(customer)}
                      startIcon={<DeleteOutline />}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      <Modal
        open={showPartners}
        onClose={() => setshowPartners(false)}
        aria-labelledby="modal-title"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          maxHeight: "900px",
        }}
        aria-describedby="modal-description"
      >
        <Grow in={showPartners}>
          <div className="bg-white h-[90%] p-10 w-1/2 rounded-3xl overflow-scroll">
            <div
              onClick={() => setshowPartners(false)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                cursor: "pointer",
                alignItems: "center",
              }}
            >
              <Typography id="modal-title" variant="h4" component="h2">
                Requested Partners
              </Typography>
              <CloseIcon />
            </div>

            <div className="w-full">
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow className="font-semibold">
                      <TableCell>
                        <strong>Partner Id</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Partner Name</strong>
                      </TableCell>
                      <TableCell>
                        <strong>mobileNumber</strong>
                      </TableCell>
                      {/* <TableCell><strong>Service</strong></TableCell> */}
                      <TableCell>
                        <strong>City</strong>
                      </TableCell>
                      <TableCell>
                        <strong>PinCode</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Status</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {availablePartners?.map((item) => (
                    <TableRow className="">
                      <TableCell>{item?.partner?.uniqueId}</TableCell>
                      <TableCell>{item?.partner?.name}</TableCell>
                      <TableCell>{item?.partner?.mobileNumber}</TableCell>
                      {/* <TableCell>{item?.name}</TableCell> */}
                      <TableCell>{item?.partner?.city}</TableCell>
                      <TableCell>{item?.partner?.pincode}</TableCell>
                      <TableCell>
                        {item?.status === "accepted" && (
                          <Chip label="Accepted" color="success" size="small" />
                        )}
                        {item?.status === "requested" && (
                          <Chip
                            label="Requested"
                            color="warning"
                            size="small"
                          />
                        )}
                        {item?.status !== "accepted" &&
                          item?.status !== "requested" && (
                            <Chip label={item?.status} size="small" />
                          )}
                      </TableCell>
                    </TableRow>
                  ))}
                </Table>
              </TableContainer>
            </div>
          </div>
        </Grow>
      </Modal>

      <Modal
        open={showAddresses}
        onClose={() => setShowAddresses(false)}
        aria-labelledby="addresses-modal-title"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grow in={showAddresses}>
          <div className="bg-white p-10 w-1/2 rounded-3xl overflow-scroll max-h-[90%]">
            <div
              onClick={() => setShowAddresses(false)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                cursor: "pointer",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <Typography id="addresses-modal-title" variant="h4" component="h2">
                User Addresses
              </Typography>
              <CloseIcon />
            </div>

            <div className="w-full">
              {userAddresses?.length > 0 ? (
                userAddresses.map((address, index) => (
                  <Paper key={index} sx={{ padding: 2, marginBottom: 2 }}>
                    <Typography variant="h6" gutterBottom>
                      Address {index + 1}
                    </Typography> 
                    {address?.userAddressId==activeRequest?.addressId && (
                      <Chip
                        label="Active Address"
                        color="primary"
                        size="small"
                        sx={{ marginBottom: 1 }}
                      />
                    )}
                    <Typography variant="body1">
                      <strong>Full Address:</strong> {address?.fullAddress || 'N/A'}
                    </Typography>
                    <Typography variant="body1">
                      <strong>City:</strong> {address?.city || 'N/A'}
                    </Typography>
                    <Typography variant="body1">
                      <strong>State:</strong> {address?.state || 'N/A'}
                    </Typography>
                    <Typography variant="body1">
                      <strong>Pincode:</strong> {address?.pincode || 'N/A'}
                    </Typography>
                    <Typography variant="body1">
                      <strong>Landmark:</strong> {address?.landmark || 'N/A'}
                    </Typography>
                  </Paper>
                ))
              ) : (
                <Typography variant="body1" textAlign="center">
                  No addresses found
                </Typography>
              )}
            </div>
          </div>
        </Grow>
      </Modal>
    </Container>
  );
};

export default Requests;
